import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="theme"
export default class extends Controller {
  static targets = ["lightIcon", "darkIcon"]

  connect() {
    this.applyTheme()
    
    // Listen for system theme changes
    window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", () => {
      if (!this.hasUserPreference()) {
        this.applyTheme()
      }
    })
  }

  toggle() {
    const currentTheme = this.getCurrentTheme()
    const newTheme = currentTheme === "dark" ? "light" : "dark"
    
    localStorage.setItem("theme", newTheme)
    this.setTheme(newTheme)
  }

  applyTheme() {
    const theme = this.getCurrentTheme()
    this.setTheme(theme)
  }

  getCurrentTheme() {
    // Check localStorage first
    const stored = localStorage.getItem("theme")
    if (stored) {
      return stored
    }
    
    // Fall back to system preference
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"
  }

  hasUserPreference() {
    return localStorage.getItem("theme") !== null
  }

  setTheme(theme) {
    if (theme === "dark") {
      document.documentElement.classList.add("dark")
    } else {
      document.documentElement.classList.remove("dark")
    }
    
    this.updateIcons(theme)
  }

  updateIcons(theme) {
    if (this.hasLightIconTarget && this.hasDarkIconTarget) {
      if (theme === "dark") {
        this.lightIconTarget.classList.remove("hidden")
        this.darkIconTarget.classList.add("hidden")
      } else {
        this.lightIconTarget.classList.add("hidden")
        this.darkIconTarget.classList.remove("hidden")
      }
    }
  }
}

